

import _http_v1 from "@packs/http_requests/_http_v1"
import store from "../store/store";
import _http_v2 from "@packs/http_requests/_http_v2";

const stationHelper = {
    async getStations(params){
        let stations = await _http_v1.request('station_prefixes/simplify', 'GET', params)
        
        return stations
    },
    async getMeasurements(type){
        
        let hour = type === 'flu' ? 3 : store.mainConfigStore.getHours()

        let DATE = store.mainConfigStore.getDate()

        let measurements

        if(type === 'plu'){
            measurements = await _http_v2.request('measurements/now', 'GET', {from_date: DATE, station_type_id: 2,hours: hour , show_all:true, serializer: 'complete', public:true})
        } else {
            measurements = await _http_v2.request('measurements/now', 'GET', {from_date: DATE, station_type_id: 1,hours: hour , group_type: 'minute', parameter_type_ids: [2], serializer: 'complete', public:true})
        }        

        return measurements
    }
}

export default stationHelper